<template>
    <div class="tabs">
        <header class="tabs__header">
            <button
                v-for="tab of tabs"
                class="tabs__trigger"
                :class="{
                  'tabs__trigger_active': tab.key === activeTabKey,
                  'tabs__trigger_disabled': tab.disabled
                }"
                :key="tab.key"
                @click.prevent="setActiveTab(tab)"
            >
                {{ tab.name }}
            </button>
        </header>

        <div
          v-for="tab of tabs"
          v-show="tab.key === activeTabKey"
          class="tabs__tab"
          :key="tab.key"
        >
            <slot :name="tab.key" />
        </div>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
    tabs: {
      required: true,
      type: Array,
      validator(value) {
        return Array.isArray(value) && value.every(tab => tab.key && tab.name);
      },
    },
  },
  data() {
    return {
      activeTabKey: this.value || this.tabs?.[0]?.key,
    };
  },
  methods: {
    setActiveTab(tab) {
      if (tab.disabled) {
        return;
      }

      this.activeTabKey = tab.key;
    },
  },
  watch: {
    activeTabKey(newValue) {
      if (this.value === newValue) {
        return;
      }

      this.$emit('input', newValue);
    },
    value(newValue) {
      if (this.activeTabKey === newValue) {
        return;
      }

      this.activeTabKey = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  min-width: 0;

  &__header {
    display: flex;
    overflow: auto;
    margin-bottom: 15px;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__trigger {
    font-size: 14px;
    font-family: var(--text-primary-font-family);
    color: var(--text-primary);
    font-weight: 500;
    padding: 5px 8px;
    border-bottom: 2px solid var(--tertiary-accent);
    transition: all .3s;

    &_active {
      border-bottom-color: var(--primary);
    }

    &_disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
